import { createStore, compose, applyMiddleware } from 'redux';
import {DialogMiddleware} from '../modules/layout/actions';
import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import logger from 'redux-logger';
import rootReducer from './reducers';
import thunk from 'redux-thunk';

const middleware = [
    DialogMiddleware,
    logger(),
    thunk
];

const enhancers = compose(
    applyMiddleware(...middleware),
    window.devToolsExtension ? window.devToolsExtension() : f => f
);

/**
 * CREATE THE STORE
 */

const store = createStore(
    rootReducer,
    {},
    enhancers
);

export const history = syncHistoryWithStore(browserHistory, store);
export { store };



/** WEBPACK FOOTER **
 ** ./src/redux/store.js
 **/